var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Socials / Mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 4.5L7.58073 7.9592L7.58225 7.96047C8.09089 8.33346 8.34535 8.52007 8.62407 8.59216C8.87042 8.65588 9.12938 8.65588 9.37573 8.59216C9.6547 8.52001 9.9099 8.33285 10.4194 7.9592C10.4194 7.9592 13.3576 5.70445 15 4.5M2.25 11.8501V6.15015C2.25 5.31007 2.25 4.88972 2.41349 4.56885C2.5573 4.2866 2.7866 4.0573 3.06885 3.91349C3.38972 3.75 3.81007 3.75 4.65015 3.75H13.3501C14.1902 3.75 14.6097 3.75 14.9305 3.91349C15.2128 4.0573 15.4429 4.2866 15.5867 4.56885C15.75 4.8894 15.75 5.30925 15.75 6.14768V11.8527C15.75 12.6911 15.75 13.1104 15.5867 13.4309C15.4429 13.7132 15.2128 13.9429 14.9305 14.0867C14.61 14.25 14.1908 14.25 13.3523 14.25H4.64768C3.80925 14.25 3.3894 14.25 3.06885 14.0867C2.7866 13.9429 2.5573 13.7132 2.41349 13.4309C2.25 13.11 2.25 12.6902 2.25 11.8501Z",
    stroke: "#726C6C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.2e276003dd5685e01bd0de8917defe47.svg";
export { ForwardRef as ReactComponent };